import {
    IconButton,
    FontWeights,
    FontSizes,
    Stack,
    Text,
    DetailsList,
    DetailsListLayoutMode,
    ScrollablePane,
    SelectionMode,
    Sticky,
    Modal
} from "@fluentui/react"
import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import Type from './../../Redux/Type';
import { NeutralColors, SharedColors } from '@uifabric/fluent-theme/lib/fluent/FluentColors';
import moment from "moment";

const PriceTableModal = () => {

    const dispatch = useDispatch();

    const {
        arrayHuyen, listPrice,
        arrayXa, arrayLoaiDat, loadingSearch,
        arrayDuong, arrayViTri, arrayDoan
    } = useSelector(state => state.priceTableTerm);

    const _renderItemColumn = (item, index, column) => {
        const fieldContent = item[column.fieldName];

        switch (column.key) {
            case '9':
                return <span>{fieldContent.toLocaleString('it-IT', { style: 'currency', currency: 'VND' })}</span>;
            case '12':
                return <span>{moment(fieldContent).format('DD/MM/YYYY')}</span>;
            case '13':
                return <span>{moment(fieldContent).format('DD/MM/YYYY')}</span>;
            default:
                return <span>{fieldContent}</span>;
        }
    }

    const _renderHeaderColumn = (detailsHeaderProps, defaultRender) => {
        return (
            <Sticky>
                {defaultRender(detailsHeaderProps)}
            </Sticky>
        )
    };
    useEffect(() => { }, [])
    const onClose = () => dispatch({ type: Type.SET_PRICE_TB_TERM, route: 'showResult', value: false });
    return (
        <Modal styles={{ width: '90vw' }} isOpen={true}
            // onDismiss={this.onCloseModal}
            isBlocking={false}
            dragOptions={null}
        >
            <Stack styles={styles.container}>
                <Stack horizontal horizontalAlign={'space-between'} style={styles.headerView} verticalAlign={'center'}>
                    <Text styles={styles.headerTitle}>Thông tin giá đất</Text>
                    <IconButton
                        styles={styles.closeButton}
                        iconProps={{ iconName: 'Cancel' }}
                        onClick={onClose}
                    />
                </Stack>
                <Stack style={{ flex: 1, position: "relative", marginLeft: 16 }}>
                    <ScrollablePane>
                        <DetailsList
                            styles={{ root: { paddingBottom: 20 } }}
                            items={listPrice}
                            columns={column}
                            setKey="multiple"
                            onRenderItemColumn={_renderItemColumn}
                            layoutMode={DetailsListLayoutMode.justified}
                            selectionMode={SelectionMode.none}
                            onRenderDetailsHeader={_renderHeaderColumn}
                        />
                    </ScrollablePane >
                </Stack>
            </Stack>
        </Modal>
    )
}
export default PriceTableModal

const column = [
    { key: '1', name: 'id', fieldName: 'id', maxWidth: 50, minWidth: 50 },
    { key: '4', name: 'Huyện', fieldName: 'HuyenQuan', isMultiline: true, maxWidth: 90, minWidth: 90 },
    { key: '3', name: 'Đường', fieldName: 'Duong', maxWidth: 200, isMultiline: true, minWidth: 200 },
    { key: '5', name: 'Đoạn đường', fieldName: 'DoanDuong', isMultiline: true, maxWidth: 200, minWidth: 200 },
    { key: '2', name: 'Loại đất', fieldName: 'LoaiDat', isMultiline: true, maxWidth: 150, minWidth: 80 },
    { key: '8', name: 'Vị trí', fieldName: 'ViTri', maxWidth: 90, minWidth: 90 },
    { key: '9', name: 'Giá', fieldName: 'GiaDat', maxWidth: 80, minWidth: 80 },
    { key: '10', name: 'Hệ số điều chỉnh', fieldName: 'HeSoDieuChinh', maxWidth: 100, minWidth: 100 },
    { key: '11', name: 'Hệ số VHM', fieldName: 'HeSoVHM', maxWidth: 80, minWidth: 80 },
    { key: '12', name: 'Hiệu lực từ', fieldName: 'HieuLucTu', maxWidth: 80, minWidth: 80 },
    { key: '13', name: 'Hiệu lực đến', fieldName: 'HieuLucDen', maxWidth: 80, minWidth: 80 },
]
const styles = {
    container: {
        root: {
            width: '90vw',
            height: '90vh',
            overflow: 'hidden',

        }
    },
    headerView: {
        paddingLeft: 16, paddingRight: 16,
        paddingTop: 4,
        paddingBottom: 8,
        backgroundColor: SharedColors.cyanBlue10,
        marginBottom: 16
    },
    headerTitle: {
        root: {
            fontSize: FontSizes.mediumPlus,
            color: NeutralColors.white,
            fontWeight: FontWeights.bold
        }
    },
    closeButton: {
        root: {
            color: NeutralColors.white,
            marginLeft: 'auto',
            marginTop: '4px',
            marginRight: '2px',
        },
        rootHovered: {
            color: NeutralColors.white,
            backgroundColor: SharedColors.blue10
        },
        rootPressed: {
            color: SharedColors.greenCyan10,
            backgroundColor: SharedColors.blue10
        }
    },
    generalView: {
        marginLeft: 16,
        marginRight: 16,
        borderBottom: '1px solid #eee',
        paddingBottom: 20
    },
    generalTitle: {
        root: {
            fontSize: FontSizes.smallPlus,
            fontWeight: FontWeights.semibold,
            color: SharedColors.cyanBlue10
        }
    },
    generalContent: {
        root: {
            fontSize: FontSizes.medium,
            // fontWeight: FontWeights.semibold
        }
    }

}
